export default __webpack_public_path__ + "static/media/P1010730.653a0058.jpg";